import Textarea from './Textarea';

// export types
export type { TextareaProps } from './Textarea';

// export components
export { Textarea };

export default Textarea;
